var _excluded = ["children", "asChild"],
    _excluded2 = ["children", "forceMount", "container"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { CrossIcon } from '@grupoboticario/flora-react-icons';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import { forwardRef, styled } from '@grupoboticario/flora-react-system';
import { CloseButtonStyles, HeaderStyles, OverlayStyles, BodyStyles, FooterStyles, TriggerStyles } from './styles';
export var Dialog = DialogPrimitive.Root;
export var DialogTitle = DialogPrimitive.Title;
export var DialogDescription = DialogPrimitive.Description;
export var DialogTrigger = styled(DialogPrimitive.Trigger, TriggerStyles);
export var DialogFooter = styled('footer', FooterStyles);
export var DialogHeader = styled('header', HeaderStyles);
export var DialogBody = styled('div', BodyStyles); // styled

var StyledDialogOverlay = styled('div', OverlayStyles);
var StyledDialogClose = styled(DialogPrimitive.Close, CloseButtonStyles);
export var DialogClose = forwardRef((_ref, forwardedRef) => {
  var {
    children,
    asChild = false
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  if (asChild) return /*#__PURE__*/React.createElement(DialogPrimitive.Close, _extends({
    "aria-label": "Fechar"
  }, props, {
    asChild: true
  }), children);
  return /*#__PURE__*/React.createElement(StyledDialogClose, _extends({
    "aria-label": "Fechar"
  }, props, {
    ref: forwardedRef
  }), /*#__PURE__*/React.createElement(CrossIcon, {
    color: "$linkDefault"
  }));
});
export var DialogContent = forwardRef((_ref2, forwardedRef) => {
  var {
    children,
    forceMount,
    container
  } = _ref2,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded2);

  return /*#__PURE__*/React.createElement(DialogPrimitive.Portal, {
    forceMount: forceMount,
    container: container
  }, /*#__PURE__*/React.createElement(StyledDialogOverlay, {
    "data-flora": "overlay"
  }), /*#__PURE__*/React.createElement(DialogPrimitive.Content, _extends({}, props, {
    ref: forwardedRef
  }), children));
});
//# sourceMappingURL=Dialog.js.map